import React from 'react'
import { nanoid } from 'nanoid'

export const generateSkeletons = (component, amount) => {
  let arr = []

  for (let i = 0; i < amount; i++) {
    arr.push(React.cloneElement(component, { key: nanoid() + i }))
  }

  return arr
}
